import { createSlice } from "@reduxjs/toolkit";
import {
  IPersonalAccidentPlanRate,
  IShelfPlanAdminCost,
  IShelfPlanInformation
} from "components/personalAccident/shelfPlans/information/Information.interface";
import { IPersonalAccidentPlanServiceRateConfiguration } from "container/personalAccident/planSetup/b2c/shelfPlans/services/shelfPlanService.interface";
import { RootState } from "redux/store";
import { SALE_POINTS } from "shared/constant";
import { IListOfValues } from "shared/interface/types";

interface IPersonalAccidentInitialState {
  ShelfPlan: IShelfPlanInformation;
  ActivePriceSalePoint: keyof typeof SALE_POINTS;
  ShelfPlanAdminCost: IShelfPlanAdminCost;
  PersonalAccidentPlanRateConfiguration: IPersonalAccidentPlanRate[];
  PersonalAccidentPlanActivePlans: string[];
  PersonalAccidentPlanService: {
    id: string;
    personalAccidentPlanServiceRateConfiguration?: IPersonalAccidentPlanServiceRateConfiguration[];
    service?: { contribution: IListOfValues; id: number; name: string };
  };
}
const initialState: IPersonalAccidentInitialState = {
  ShelfPlan: {
    personalAccidentPlanGenders: [],
    planTypeId: 0,
    priceTypeId: 0,
    id: "",
    takafulProviderId: 0,
    productName: "",
    salePoint: [],
    renewalMinAge: 0,
    renewalMaxAge: 0
  },
  PersonalAccidentPlanService: {
    id: ""
  },
  ActivePriceSalePoint: "",
  ShelfPlanAdminCost: {
    adminCostMax: 0,
    adminCostMaxTypeId: 0,
    adminCostMin: 0,
    adminCostMinTypeId: 0
  },
  PersonalAccidentPlanRateConfiguration: [],
  PersonalAccidentPlanActivePlans: []
};

const personalAccidentSlice = createSlice({
  name: "personalAccident",
  initialState,
  reducers: {
    AddPersonalAccidentShelfPlan: (state, action) => {
      state.ShelfPlan = action.payload;
    },
    AddPersonalAccidentPlanService: (state, action) => {
      state.PersonalAccidentPlanService = action.payload;
    },
    DeletePersonalAccidentShelfPlan: state => {
      state.ShelfPlan = initialState.ShelfPlan;
    },
    UpdateActiveSalePoint: (state, action) => {
      state.ActivePriceSalePoint = action.payload;
    },
    UpdateAdminCostForShelfPlanPrice: (state, action) => {
      state.ShelfPlanAdminCost = action.payload;
    },
    UpdatePersonalAccidentPlanRateConfiguration: (state, action) => {
      state.PersonalAccidentPlanRateConfiguration = action.payload;
    },
    UpdatePersonalAccidentActivePlan: (state, action) => {
      state.PersonalAccidentPlanActivePlans = action.payload;
    }
  }
});

export const {
  AddPersonalAccidentShelfPlan,
  DeletePersonalAccidentShelfPlan,
  UpdateActiveSalePoint,
  UpdateAdminCostForShelfPlanPrice,
  UpdatePersonalAccidentPlanRateConfiguration,
  UpdatePersonalAccidentActivePlan,
  AddPersonalAccidentPlanService
} = personalAccidentSlice.actions;
export default personalAccidentSlice.reducer;

export const getPersonalAccidentShelfPlan = (state: RootState): IPersonalAccidentInitialState => state.personalAccident;
